<div class="d-flex flex-column gap-3">
  <div class="responsive-card d-flex flex-column gap-4">
    <div class="card-title-container">
      <div class="d-flex flex-column gap-2">
        <div class="responsive-card-title">{{ cardTitle }}</div>
        <div class="responsive-card-description">
          {{ description }}
        </div>
      </div>
      <app-primary-button
        class="d-flex mt-auto"
        [leftIconSrc]="'assets/icons/white/Plus.svg'"
        [size]="BaseButtonSizeEnum.xs"
        (buttonClicked)="addRow()"
        i18n>
        New Row
      </app-primary-button>
    </div>
    <div class="table-container">
      <div class="scrollable-columns">
        <div class="row-header">
          <div class="validation-header"></div>
          <div class="validation-header"></div>
          <div class="column-header last-name" i18n>Last Name</div>
          <div class="column-header first-name" i18n>First Name</div>
          <div class="column-header" i18n>Date of Birth</div>
          <div class="column-header" i18n>SIN</div>
          <div class="column-header email" i18n>Email</div>
          <div class="column-header" i18n>Employment Start</div>
        </div>
        <div
          class="row-content"
          [ngClass]="{ 'row-error': rowHasError(i) }"
          (focusout)="onRowBlur($event, i)"
          *ngFor="let row of rows?.controls; let i = index"
          [formGroup]="row">
          <div class="validation-col delete-col" ngbDropdown #contributionMenu="ngbDropdown" container="body">
            <div ngbDropdownToggle>
              <button
                [disabled]="rows.controls.length === 1"
                type="button"
                class="no-style-button remove-row-button"
                (click)="contributionMenu.toggle(); $event.stopPropagation()"></button>
            </div>
            <div ngbDropdownMenu>
              <button class="no-style-button delete-button" type="button" ngbDropdownItem (click)="removeRow(i)" i18n>
                Delete Row
              </button>
            </div>
          </div>
          <div class="validation-col error-col">
            <img class="error-icon" *ngIf="rowHasError(i)" [src]="'assets/icons/red/ExclamationCircle.svg'" />
          </div>
          <div class="input-container">
            <app-member-table-text-input
              [error]="row.submitAttempted && row.controls.lastName.invalid"
              controlId="lastName"
              [formControlName]="'lastName'" />
          </div>
          <div class="input-container">
            <app-member-table-text-input
              [error]="row.submitAttempted && row.controls.firstName.invalid"
              controlId="firstName"
              [formControlName]="'firstName'" />
          </div>
          <div class="input-container">
            <app-member-table-date-input
              [error]="row.submitAttempted && row.controls.dateOfBirth.invalid"
              [formControlName]="'dateOfBirth'"
              controlId="dateOfBirth"
              placeholder="dd/mm/yyyy"
              i18n-placeholder />
          </div>
          <div class="input-container">
            <app-member-table-sin-input
              [error]="row.submitAttempted && row.controls.socialInsuranceNumber.invalid"
              [formControlName]="'socialInsuranceNumber'"
              controlId="socialInsuranceNumber" />
          </div>
          <div class="input-container email">
            <app-member-table-email-input
              [error]="row.submitAttempted && row.controls.email.invalid"
              controlId="email"
              [formControlName]="'email'" />
          </div>
          <div class="input-container">
            <app-member-table-date-input
              (valueChanged)="checkEmploymentStartDate($event, i)"
              [error]="row.submitAttempted && row.controls.employmentStartDate.invalid"
              [formControlName]="'employmentStartDate'"
              controlId="employmentStartDate"
              placeholder="dd/mm/yyyy"
              i18n-placeholder />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end align-items-center gap-3">
    <app-secondary-button [size]="BaseButtonSizeEnum.sm" (buttonClicked)="cancelClicked.emit()" i18n>
      Cancel
    </app-secondary-button>
    <app-primary-button [size]="BaseButtonSizeEnum.sm" [isLoading]="isLoading" (buttonClicked)="submitTable()">
      {{ primaryButtonText }}
    </app-primary-button>
  </div>
</div>
